const TV_USER_AGENT_PATTERN =
    /\b(?:smart-?tv|smarttv|vidaa|hisense|hbbtv|netcast|web0s|webos|tizen|viera|bravia|aquos|dtv|googletv|android tv|apple ?tv|roku|crkey|aft(?:b|m|s|t|mm)|fire tv|nexus player|shield android tv|opera tv|tv safari)\b/i;

type TVDeviceSignals = {
    maxTouchPoints: number;
    screenWidth: number;
    screenHeight: number;
};

/** Detects browsers running on televisions without classifying normal mobile Android devices as TVs. */
export const isTVDevice = (userAgent?: string, suppliedSignals?: TVDeviceSignals): boolean => {
    const resolvedUserAgent =
        userAgent ??
        (typeof navigator !== "undefined" ? navigator.userAgent : "");

    // The Android shell supplies this before its first navigation. It remains
    // authoritative when a WebView reports no touch points or desktop-style UA.
    if (/\bQitDevice\/Handheld\b/i.test(resolvedUserAgent)) return false;
    if (/\bQitDevice\/TV\b/i.test(resolvedUserAgent)) return true;

    if (TV_USER_AGENT_PATTERN.test(resolvedUserAgent)) return true;

    const signals = suppliedSignals ?? {
        maxTouchPoints: typeof navigator !== "undefined" ? navigator.maxTouchPoints || 0 : 0,
        screenWidth: typeof screen !== "undefined" ? screen.width || 0 : 0,
        screenHeight: typeof screen !== "undefined" ? screen.height || 0 : 0,
    };

    // Android TV browsers in "desktop site" mode often remove "Android TV"
    // but retain Android. A large, non-touch display distinguishes them from
    // phones and tablets without classifying ordinary desktop browsers as TVs.
    return /\bandroid\b/i.test(resolvedUserAgent) &&
        signals.maxTouchPoints === 0 &&
        Math.min(signals.screenWidth, signals.screenHeight) >= 720;
};
